import { Button, Typography } from "neetoui";
import { Trans } from "react-i18next";

import { WIDGET_HELP_LINKS, WIDGET_TYPES } from "./constants";

const ChatWidgetBody = ({ widgets }) => (
  <>
    {widgets.includes(WIDGET_TYPES.engage) && (
      <Trans
        i18nKey="neetoMolecules.widget.email.body.values.embedCode.engageHelp"
        values={{ helpLink: WIDGET_HELP_LINKS.engage }}
        components={{
          p: <Typography className="mb-2" style="body2" />,
          a: (
            <Button
              href={WIDGET_HELP_LINKS.engage}
              rel="noreferrer"
              style="link"
              target="_blank"
            />
          ),
        }}
      />
    )}
    {widgets.includes(WIDGET_TYPES.chat) && (
      <Trans
        i18nKey="neetoMolecules.widget.email.body.values.embedCode.chatHelp"
        values={{ helpLink: WIDGET_HELP_LINKS.chat }}
        components={{
          p: <Typography className="mb-2" style="body2" />,
          a: (
            <Button
              href={WIDGET_HELP_LINKS.chat}
              rel="noreferrer"
              style="link"
              target="_blank"
            />
          ),
        }}
      />
    )}
    {widgets.includes(WIDGET_TYPES.replay) && (
      <Trans
        i18nKey="neetoMolecules.widget.email.body.values.embedCode.replayHelp"
        values={{ helpLink: WIDGET_HELP_LINKS.replay }}
        components={{
          p: <Typography className="mb-2" style="body2" />,
          a: (
            <Button
              href={WIDGET_HELP_LINKS.replay}
              rel="noreferrer"
              style="link"
              target="_blank"
            />
          ),
        }}
      />
    )}
  </>
);

export default ChatWidgetBody;
